//React component
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { Modal, Col, ListGroup, Badge, Row, Button, Alert } from 'react-bootstrap';
import { printData } from '../../../utils/PrintData';
import moment from 'moment-timezone';
import { OrdersFetchAPI } from '../../../api/Orders';
import { OrderReturnFetchAPI } from '../../../api/Paymentpost/OrderReturn';

//utisls
import { RenderIf } from '../../utils/RenderIf';
import { checkUserPermission } from '../../utils/CheckUserPermitions';
import { buildCloudinaryImageUrl } from '../../../utils/CloudinaryImageUrl';
import { PaymentOperations } from '../../../utils/PaymentOperations';
//Api 
import { RequestLocalFetchAPI } from '../../../api/Paymentpost/RequestLocal';
import { MachinesFetchAPI } from '../../../api/Machines';
import { PaymentMethodFetchAPI } from '../../../api/Paymentpost/PaymentMethod';
import { LanguagesFetchAPI } from '../../../api/Languages';
import { PrinterFetchAPI } from '../../../api/Printer';
import { EvertechFetchAPI } from '../../../api/Evertech';
import { WarehouseFetchAPI } from '../../../api/Paymentpost/Warehouse';
//Alerts
import ErrorAlert from '../../Alerts/ErrorAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';
//Components
import ModalWarehouses from '../../PaymentPost/ModalWarehouses';
import ModalCategoriesPrinter from '../EditIP/ModalCategoriesPrinter';
import ModalAddCategories from '../EditIP/ModalAddCategorie';
import ModalEditIp from '../EditIP/ModalEditIp';
//We import the process payment function
import SuccessAlert from '../../Alerts/SuccessAlert';
import IntegrationsList from '../IntegrationList/IntegrationsList';
import TableSettingsTab from '../../../../components/PaymentPost/TableSettingsTab';
//Sounds 
import newOrderSound from '../../../assets/sounds/doorbell.mp3';
//IMG
import defaultImage from "../../../assets/img/default.png";
import './ConfigModal.css';
// We create a function to get the balance of an EBT card
const evertechEbtBalance = async (data) => {
    try {
        // We make the sale
        const res = await EvertechFetchAPI.makeEBTOperation(data);
        // We check the response of the server in base of the response of the pin pad
        if (res && res.data !== undefined) {
            // If the response exists, we check the approval code 
            if (res.data.approval_code !== "00") {
                console.log("Approval code error");
                ErrorAlert("Error", "Error en la comunicación con el servidor", "error");
                //We show the modal with the voucher
                // If the approval code is not 00, we return an error
                return ({
                    status: 400,
                    data: res.data
                });
            } else {
                ErrorAlert(`Exito
                    ` , "Consulta de saldo EBT", "success", 30000000
                );
                return res;
            }
        }

        // We return the response
        return res;
    } catch (error) {
        let parsedError;
        console.log("Error caught in evertechSale:", error);
        ErrorAlert("Error", "Error en la comunicación con el servidor", "error");
        // If the error is already an object, no need to parse
        if (typeof error === 'object' && error !== null) {
            parsedError = error;
        } else {
            // We try to convert the error into an object
            try {
                parsedError = JSON.parse(error);
            } catch (e) {
                // If parsing fails, return a generic error object
                parsedError = { status: 500, message: error };
            }
        }

        // Throw the formatted error object
        if (parsedError.status && parsedError.data) {
            return parsedError;
        } else if (error.response) {
            throw {
                status: 400,
                data: error.response.data
            };
        } else {
            throw error;
        }
    }
};

const ModalSetting = ({ setPageLoader, codeParthner }) => {
    //Params 
    let user = localStorage.getItem('user');
    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = localStorage.getItem('branchoffice');
    let business = localStorage.getItem('business');
    let machine = localStorage.getItem('machine');
    const [machine_name_get, setMachine_name_get] = useState("");
    const [paymentMethod_list, setpaymentMethod_list] = useState([])
    const [printers_list, setPrinters_list] = useState([])
    const [eventHandle, setEventHandle] = useState(0)
    const [eventHandlerSwitch, setEventHandlerSwitch] = useState(0);
    const [infolanguage, setInfolanguage] = useState({ language: { name: "Español" } })
    const [showModalSetting, setshowModalSetting] = useState(false);
    const [languages, setLanguages] = useState([]);
    const [selectLanguage, setSelectLanguage] = useState('');
    const [ebtVoucher, setEbtVoucher] = useState(null);
    const [ebtBalanceModal, setEbtBalanceModal] = useState(false);
    const [showModalWarehouses, setShowModalWarehouses] = useState(false)
    const [warehouses, setWarehouses] = useState([])
    const [temporalOrders, setTemporalOrders] = useState([])
    const [warehouseSelected, setWarehouseSelected] = useState(() => {
        if (localStorage.getItem('warehouse') !== "" && localStorage.getItem('warehouse') !== null && localStorage.getItem('warehouse') !== undefined) {
            return JSON.parse(localStorage.getItem('warehouse'))
        } else {
            return { name: "Selecciona una bodega", id: 0 }
        }
    })
    // 🔔 Alarm audio control
    const alarmAudioRef = useRef(null);
    const [alarmActive, setAlarmActive] = useState(false);

    const [showModalipPrinterAdd, setshowModalipPrinterAdd] = useState(false);
    const [ip_printerInput, setIp_printerInput] = useState("");
    let ventanaYappy = 0;


    const saveipPinter = () => {
        localStorage.setItem('ip_printer', ip_printerInput)
        ErrorAlert("", "Ip guardada con exito", "success")
        setIp_printerInput("")
        setshowModalipPrinterAdd(false)

    }

    const removedIpExternalPrinter = () => {
        localStorage.removeItem('ip_printer')
        ErrorAlert("", "Ip removida con exito", "success")
        setEventHandle(1)
    }

    //We validate if the user is logged in
    if (user === null || user === undefined || user === '' || user === 'null') {
        user = {
            name: 'No registrado',
            img: 'https://www.pngitem.com/pimgs/m/30-307416_profile-icon-png-image-free-download-searchpng-employee.png'
        }
    } else {
        user = JSON.parse(localStorage.getItem('user'))
    }

    //We validate if the branch
    if (branchoffice !== null && branchoffice !== undefined && branchoffice !== '') {
        branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    }

    //We validate if the branch
    if (business !== null && business !== undefined && business !== '') {
        business = JSON.parse(localStorage.getItem('business'))
    }

    //We validate if the branch
    if (machine !== null && machine !== undefined && machine !== '') {
        machine = JSON.parse(localStorage.getItem('machine'))
    }

    const getLanguages = async () => {
        try {
            const response = await LanguagesFetchAPI.getLanguages(token);
            setLanguages(response.data.languages)

        } catch (err) {
            console.log(err);
        }
    }


    const [switchExternalMenu, setSwitchExternalMenu] = useState(() => {
        if (localStorage.getItem('external_menu_manual') == "true") {
            return true
        } else {
            return false
        }
    })

    const [editPrice, setEditPrice] = useState(() => {
        if (localStorage.getItem('edit_price') == "true") {
            return true
        } else {
            return false
        }
    })

    const handleSwitchChange = () => {
        let external_menu_manual = localStorage.getItem('external_menu_manual')
        if (external_menu_manual == "false") {
            localStorage.setItem('external_menu_manual', "true")
            setSwitchExternalMenu(true)
            setEventHandlerSwitch(1)
        } else {
            setSwitchExternalMenu(false)
            localStorage.setItem('external_menu_manual', "false")
            setEventHandlerSwitch(1)
        }
        setPageLoader(1)
    }


    const handleSwitchChangeEditPrice = () => {
        let editPriceStorage = localStorage.getItem('edit_price')
        if (editPriceStorage == "false") {
            localStorage.setItem('edit_price', "true")
            setEditPrice(true)
            setEventHandlerSwitch(1)
        } else {
            setEditPrice(false)
            localStorage.setItem('edit_price', "false")
            setEventHandlerSwitch(1)
        }

        LoadingAlert("Cambiando configuración", "Espere un momento por favor")
        setInterval(() => {
            window.location.reload(true);
        }, 3000);
        setPageLoader(1)
    }

    //Function to get the warehouse of branch office
    const getWarehouseByBrachoffice = async (branchoffice_id) => {
        try {
            const response = await WarehouseFetchAPI.getwarehousebybracnhoffice(branchoffice_id, 0, token)
            let filteredWarehouses = response.data.warehouses.filter(warehouse => warehouse.is_enable == 1)
            setWarehouses(filteredWarehouses)
        } catch (err) {
            setWarehouses([])
            console.log(err);
        }
    }

    const actualDate = moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD')
    const minDate = moment(actualDate).subtract(3, 'months').format('YYYY-MM-DD');

    const getTemporalOrdersByBranch = async () => {
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let machine = JSON.parse(localStorage.getItem('machine'));
        let business = JSON.parse(localStorage.getItem('business'));
        try {
            //We call the transaction info 
            const response = await OrdersFetchAPI.getTemporalOrdersByBranch(business.code, branchoffice.code, minDate, actualDate + 'T23:59:59.000+00:00', token);
            //This are for the discount temporal orders 
            let data_orders_Temporal = response.data.temp_orders;
            // Filtrar por machine_code "3973"
            data_orders_Temporal = data_orders_Temporal.filter(order => order.machine_code === machine.code && (order.is_devolution_notification === true || order.is_discount_notification === true));
            //updateTemReturn(data_orders_Temporal[0].code, 5, "", "", "", true)
            console.log(data_orders_Temporal);
            setTemporalOrders(data_orders_Temporal)
        } catch (err) {
            //We show the error alert 
            ErrorAlert('No tiene información')
            console.log(err);
        }
    }

    // update order temporal return to delete
    const updateTemReturn = async (code, status, message, title, icon, isTruncate) => {
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business = JSON.parse(localStorage.getItem('business'))

        let business_code = business.code
        let branch_code = branchoffice.code

        if (codeParthner != 0) {
            business_code = codeParthner.business_code
            branch_code = codeParthner.branchoffice_code
        }

        let jsonUpdate = {
            "order_code": code,
            "business_code": business_code,
            "branchoffice_code": branch_code,
            "status": status
        }
        try {
            await OrderReturnFetchAPI.updateOrderTempReturn(jsonUpdate, token)

            getTemporalOrdersByBranch()
            ErrorAlert(message, title, icon)

        } catch (err) {
            console.log(err);
        }
    }


    const getMachineInfo = async () => {
        try {

            const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));
            console.log(response_machine.data.data.language);
            setInfolanguage({ language: response_machine.data.data.language });
            const response = await MachinesFetchAPI.getMachinesByBranchOfficeAndType(branchoffice.id, machine.machine_type_id, token);
            let machines_list = response.data.data

            machines_list.forEach(machine_terminal => {
                if (machine_terminal.code == machine.code) {
                    console.log(machine_terminal);
                    setMachine_name_get(machine_terminal.machine_name)
                }
            });
        } catch (err) {
            console.log(err);
        }
    }

    //function action print order
    const getPrinter = async () => {
        try {
            const response = await PrinterFetchAPI.getPrinter(token, machine.id);
            let array = response.data.printers
            for (let i = 0; i < array.length; i++) {
                array[i].status_test = "pendinete"
            }
            setPrinters_list(array)


        } catch (err) {
            console.log(err);
        }
    }


    const getPaymentMethod_list = async () => {
        try {
            const response = await PaymentMethodFetchAPI.getPaymentMethod(machine.id, token);
            console.log(response)
            let array = response.data.data
            for (let i = 0; i < array.length; i++) {
                array[i].status_test = "pendinete"
            }
            setpaymentMethod_list(array)

        } catch (err) {
            console.log(err);
        }
    }

    //function action request pyment local
    const requestPyament = async (payment_data, index) => {
        LoadingAlert("Enviando prueba metodo de pago: " + payment_data.payment, "Espere un momento por favor...")
        console.log(payment_data);
        console.log(index);
        let JsonTr = {}

        if (payment_data.payment == "Yappy") {
            JsonTr = [{
                Tipo: 'SALE',
                Producto: 'COBRAR',
                Itbms: 0.00,
                Descuento: 0.00,
                Monto: 0.00,
                TipoVenta: payment_data.payment.toUpperCase(),
                paymentMethod: payment_data,
                orderid: "0000",
                tel: "507" + "60000000",
                total: 0.00,
                subtotal: 0.00,
                taxes: 0.00,
            }];
        } else {

            let methodPayment = ""
            if (payment_data.payment == "MasterCard") {
                methodPayment = "MC"
            } else {
                methodPayment = payment_data.payment
            }

            JsonTr = [{
                Tipo: 'SALE',
                Producto: 'COBRAR',
                Itbms: 0.00,
                Descuento: 0.00,
                Monto: 0.00,
                TipoVenta: methodPayment.toUpperCase(),
                paymentMethod: payment_data,
                orderid: "0000",
            }];
        }

        try {

            const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));
            const response = await RequestLocalFetchAPI.postPaymentMethod(JsonTr, response_machine.data.data.windows_ip);

            console.log(response)
            if (payment_data.payment != "Yappy") {
                let responseCode = response.data.data.EMVStreamResponse.responseCode;
                let description = response.data.data.EMVStreamResponse.responseCodeDescription

                if (responseCode == "00") {
                    paymentMethod_list[index].status_test = "Listo"
                    ErrorAlert("Comunicacion exitosa con terminal de cobro:", "Respuesta: " + description, "success")

                } else {
                    if (description == "OPERACION CANCELADA POR EL USUARIO" || description == "TIEMPO DE ESPERA AGOTADO") {
                        paymentMethod_list[index].status_test = "Listo"
                        ErrorAlert("Comunicacion exitosa con terminal de cobro:", "Respuesta: " + description, "success")

                    } else {
                        paymentMethod_list[index].status_test = "Listo"
                        ErrorAlert("Comunicacion con terminal de cobro:", "Respuesta: " + description, "info")

                    }
                }
                setpaymentMethod_list(paymentMethod_list)
                setEventHandle(1)

            } else {

                if (response.data.data == "") {
                    ErrorAlert("Ocurrio un error con el metodo de pago: " + payment_data.payment, "Verifique los parametros del metodo.", "error")
                } else {
                    ventanaYappy = window.open(response.data.data, "test", "");
                }
            }
        } catch (err) {
            paymentMethod_list[index].status_test = "Error"

            ErrorAlert("Error de comunicacion con el servidor local", "El servidor local esta fuera de linea", "error")
            console.log(err);
            setpaymentMethod_list(paymentMethod_list)
            setEventHandle(1)
        }
    }

    //Function to get ebt evertech balance
    const getEbtBalance = async (payment_data, index) => {
        let iDefaultHostPort, DefaultHostIP, sDefaultTID, iscashback, force_duplicate, special_account, manual_entry_indicator, payment_host, basereducedtax, statetax, reducedtax, citytax;
        LoadingAlert("Consultando saldo de EBT", "Espere un momento por favor...")

        //Get parameters of payment method
        payment_data.params.forEach((param) => {
            if (param.name === "iDefaultHostport") iDefaultHostPort = param.value;
            if (param.name === "DefaultHostIP") DefaultHostIP = param.value;
            if (param.name === "sDefaultTID") sDefaultTID = param.value;
            if (param.name === "iscashback") iscashback = param.value;
            if (param.name === "force_duplicate") force_duplicate = param.value;
            if (param.name === "payment_host") payment_host = param.value;
            if (param.name === "manual_entry_indicator") manual_entry_indicator = param.value;
        });

        let data = {
            sECRStationID: machine.code,
            sCashierID: user.id !== undefined ? user.id : "0000",
            sDefaultHostIP: DefaultHostIP,
            iDefaultHostPort: iDefaultHostPort,
            sDefaultTID: sDefaultTID,
            sRefNumber: "0000",
            tips: 0,
            iscashback: iscashback,
            cashback: 0,
            total: 0,
            basereducedtax: 0,
            statetax: 0,
            reducedtax: 0,
            citytax: 0,
            manual_entry_indicator: manual_entry_indicator,
            force_duplicate: force_duplicate,
            receipt_output: "both",
            special_account: "EB",
            sTransType: "EBT",
            EBTTransType: "BALANCE",
            payment_host: payment_host
        };

        try {
            const logonres = await EvertechFetchAPI.makeLogon({
                sECRStationID: machine.code,
                sCashierID: user.id !== undefined ? user.id : "0000",
                sDefaultHostIP: DefaultHostIP,
                iDefaultHostPort: iDefaultHostPort,
                sDefaultTID: sDefaultTID,
                sRefNumber: "0000",
            });
            //We check the response of the logon request
            if (logonres.data && logonres.data.approval_code === "ZY" && logonres.data.response_message === "Connection Error - LOGON") {
                console.log("si entre porq logon fallo")
                return logonres
            } else {
                return evertechEbtBalance(data)
                    .then(async (res) => {
                        //We show the modal with the voucher
                        setEbtVoucher(res.data.receipt_output.merchant + res.data.receipt_output.customer ? res.data.receipt_output.merchant + res.data.receipt_output.customer : null);
                        setEbtBalanceModal(true);
                        //We make loggoff
                        const logoff = await EvertechFetchAPI.makeLogoff({
                            sECRStationID: machine.code,
                            sCashierID: user.id !== undefined ? user.id : "0000",
                            sDefaultHostIP: DefaultHostIP,
                            iDefaultHostPort: iDefaultHostPort,
                            sDefaultTID: sDefaultTID,
                        });
                        console.log(logoff);
                        // We return the response
                        return res;
                    })
                    .catch(async (error) => {
                        console.log("Error in catch", error);
                        ErrorAlert("Error", "Error en la comunicación con el servidor", "error");
                        const logoff = await EvertechFetchAPI.makeLogoff({
                            sECRStationID: machine.code,
                            sCashierID: user.id !== undefined ? user.id : "0000",
                            sDefaultHostIP: DefaultHostIP,
                            iDefaultHostPort: iDefaultHostPort,
                            sDefaultTID: sDefaultTID,
                        });
                        console.log(logoff);


                        let parsedError;
                        // If the error is already an object, no need to parse
                        if (typeof error === 'object' && error !== null) {
                            console.log("Error is object", error);
                            parsedError = error;
                        } else {
                            console.log("Error is not object", error);

                            try {
                                parsedError = JSON.parse(error);
                            } catch (e) {
                                parsedError = { status: 500, data: error.message };
                            }
                        }
                        console.log("Parsed error1111", parsedError);

                        // Throw the formatted error object
                        if (parsedError.status && parsedError.data) {
                            console.log("Parsed error", parsedError);
                            return parsedError;
                        } else if (error.response) {
                            console.log("Error response", error.response);
                            return {
                                status: 400,
                                data: error.response.data
                            };
                        } else {
                            console.log("Error", error);
                            return error;
                        }
                    });
            }
        } catch (err) {
            ErrorAlert("Error en la comunicación con el servidor", "Error", "error");
        }
    }

    //Function to get the balance of banesco 
    const getBanescoBalance = async (payment_data) => {

        try {
            LoadingAlert("Consultando saldo de Banesco", "Espere un momento por favor...")
            console.log(payment_data)
            let response = await PaymentOperations({
                operationType: "balance",
                integrationType: "Banesco",
                params: payment_data.params
            });
            console.log(response);
            SuccessAlert("Consulta de saldo exitosa", "Consulta de saldo Banesco", "success", 30000000);

        } catch (err) {
            console.log(err);
            ErrorAlert("error en la consulta de saldo", "Consulta de saldo Banesco", "error", 30000000);
        }
    }
    //Function to view payment list
    const viewPaymentlist = () => {
        const listView = paymentMethod_list.map((payment, index) => (
            <>


                <div className="sp-pay__item">
                    <div className="sp-pay__imgwrap">
                        <img
                            className="sp-pay__img"
                            loading="lazy"
                            src={buildCloudinaryImageUrl({ url: payment.img, width: 300, quality: "auto", type: "image" }) || defaultImage}
                            alt={payment.payment}
                        />
                    </div>

                    <div className="sp-pay__info">
                        <div className="sp-pay__name">{payment.payment + " - " + payment.integration.name}</div>

                        <div className="sp-pay__meta">
                            <RenderIf isTrue={payment.payment == "Yappy QR" || payment.payment == "Yappy" || payment.payment == "Efectivo" || payment.payment == "Credito"}>
                                <span className="sp-pay__badge is-ok"><i className="fa-solid fa-check"></i> Listo</span>
                            </RenderIf>

                            <RenderIf isTrue={(payment.payment == "Visa" || payment.payment == "Clave" || payment.payment == "MasterCard" || payment.payment == "Amex")}>
                                <RenderIf isTrue={payment.status_test == "pendinete"}>
                                    <span className="sp-pay__badge is-muted"><i className="uil uil-map-marker-info"></i> Por probar</span>
                                </RenderIf>
                                <RenderIf isTrue={payment.status_test == "Error"}>
                                    <span className="sp-pay__badge is-danger"><i className="uil uil-exclamation-triangle"></i> Error de comunicacion</span>
                                </RenderIf>
                                <RenderIf isTrue={payment.status_test == "Listo"}>
                                    <span className="sp-pay__badge is-ok"><i className="fa-solid fa-check"></i> Listo</span>
                                </RenderIf>
                            </RenderIf>

                            <RenderIf isTrue={payment.payment == "EBT" || payment.payment == "EBT Cash" || payment.payment == "EBT Unica" || payment.payment == "EBT Cash Unica"}>
                                <button className="sp-cfg__btn sp-cfg__btn--outline sp-pay__btn" onClick={() => (getEbtBalance(payment, index))}><i className="uil uil-money-insert"></i> Consultar saldo</button>
                            </RenderIf>

                            <RenderIf isTrue={(payment.payment == "Visa" || payment.payment == "Clave" || payment.payment == "MasterCard" || payment.payment == "Amex") && payment.integration.name == "Bac"}>
                                <button className="sp-cfg__btn sp-cfg__btn--outline sp-pay__btn" onClick={() => (requestPyament(payment, index))}><i className="uil uil-feedback"></i> Probar</button>
                            </RenderIf>

                            <RenderIf isTrue={(payment.payment == "Visa" || payment.payment == "Clave" || payment.payment == "MasterCard" || payment.payment == "Amex") && payment.integration.name == "Banesco"}>
                                <button className="sp-cfg__btn sp-cfg__btn--outline sp-pay__btn" onClick={() => (getBanescoBalance(payment))}><i className="uil uil-feedback"></i> Balance de puntos</button>
                            </RenderIf>
                        </div>
                    </div>
                </div>
            </>
        ));
        return (listView)
    }

    {/*view languages*/ }
    const viewLanguages = () => {

        const listItems = languages.map((language) => (
            <>

                <option value={language.id}>
                    <div translate='no'>
                        {language.name}
                    </div>
                </option>


            </>
        ));
        return (listItems)
    }

    const updateLanguage = async () => {
        try {
            let data = {
                "language_id": selectLanguage
            }
            const response = await MachinesFetchAPI.updateMachine(machine.id, data, token)
            console.log(response);

            LoadingAlert("Cambiando idioma", "Espere un momento por favor")
            setInterval(() => {
                window.location.reload(true);
            }, 3000);

        } catch (err) {
            console.log(err);
            ErrorAlert("No se puedo cambiar el idioma", "Opps", "error")
        }
    }

    const viewPrinterlist = () => {
        const listViewPrinter = printers_list.map((printer, index) => (
            <>



                <div className="sp-prn__item">
                    <div className="sp-prn__info">
                        <div className="sp-prn__head">
                            <span className="sp-prn__ic"><i className="uil uil-print"></i></span>
                            <span className="sp-prn__name">{printer.printer_name}</span>
                        </div>

                        <div className="sp-prn__meta">
                            <span className="sp-prn__row"><b>Tipo:</b> {printer.printer_type}</span>
                            <span className="sp-prn__row">
                                <b>IP:</b> {printer.ip == null ? <span className="sp-prn__muted">No registrado</span> : printer.ip}
                            </span>
                            <span className="sp-prn__row sp-prn__status">
                                <b>Estatus:</b>
                                <RenderIf isTrue={printer.status_test == "pendinete"}>
                                    <span className="sp-prn__badge is-muted"><i className="uil uil-map-marker-info"></i> Por probar</span>
                                </RenderIf>
                                <RenderIf isTrue={printer.status_test == "Error"}>
                                    <span className="sp-prn__badge is-danger"><i className="uil uil-exclamation-triangle"></i> Error de comunicacion</span>
                                </RenderIf>
                                <RenderIf isTrue={printer.status_test == "Listo"}>
                                    <span className="sp-prn__badge is-ok"><i className="fa-solid fa-check"></i> Listo</span>
                                </RenderIf>
                            </span>
                        </div>
                    </div>

                    <div className="sp-prn__acts">
                        <ModalEditIp printer={printer} setEventHandle={setEventHandle}></ModalEditIp>
                        <ModalCategoriesPrinter printer={printer}></ModalCategoriesPrinter>
                        <ModalAddCategories printer={printer}></ModalAddCategories>
                        <button className="sp-cfg__btn sp-cfg__btn--outline" onClick={() => printData({ Texto: "Prueba" }, [printer], true)}>
                            <i className="uil uil-print"></i> Probar
                        </button>
                    </div>
                </div>



            </>
        ));
        return (listViewPrinter)
    }

    // 📣 Call this when a new order arrives (PY) to start the alarm
    const startAlarm = async () => {
        const a = alarmAudioRef.current;
        if (!a) return;

        // Always restart from the beginning to ensure it's audible
        a.currentTime = 0;

        try {
            await a.play();               // Try play() — may be blocked until user gesture
            setAlarmActive(true)
        } catch (err) {
            // Autoplay blocked — show unlock UI
            stopAlarm()
            setAlarmActive(false)
        }
    };

    // 🛑 Stop alarm on any screen touch or when you accept/reject
    const stopAlarm = () => {
        const a = alarmAudioRef.current;
        if (!a) return;
        try { a.pause(); } catch (_) { }
        a.currentTime = 0;
        setAlarmActive(false);
    };


    useEffect(() => {
        (async () => {
            try {
                getMachineInfo()
                getLanguages();
                getPaymentMethod_list()
                getPrinter()
            } catch (err) {
                console.log(err);
            }
        })();
    }, [])

    // Create the HTMLAudioElement once
    useEffect(() => {
        // Create audio element only once
        const audio = new Audio(newOrderSound);
        audio.loop = true;              // loop forever
        audio.preload = 'auto';
        audio.volume = 1.0;             // adjust if needed
        alarmAudioRef.current = audio;

        // Global "touch/click anywhere" to stop the alarm when active
        const stopOnUserInteraction = () => {
            if (alarmActive) {
                stopAlarm();
            }
        };
        window.addEventListener('pointerdown', stopOnUserInteraction, { passive: true });

        return () => {
            window.removeEventListener('pointerdown', stopOnUserInteraction);
            try { audio.pause(); } catch (_) { }
            alarmAudioRef.current = null;
        };
    }, []);

    useEffect(() => {
        getPrinter();
        setEventHandle(0)
    }, [eventHandle])

    useEffect(() => { setEventHandlerSwitch(0) }, [eventHandlerSwitch])
    const [settingTab, setSettingTab] = useState('home');
    return (
        <>
            {/* <div className="dropdown-item" onClick={() => (setshowModalSetting(true), getWarehouseByBrachoffice(branchoffice.id))}>
                <i className="uil uil-setting"></i>
                <span  >  Configuracion </span>
            </div> */}

            <button className="sp-um__item" type="button" onClick={() => (setshowModalSetting(true), getWarehouseByBrachoffice(branchoffice.id))}>
                <i className="uil uil-setting"></i>
                Configuración
                <i className="uil uil-angle-right sp-um__chev"></i>
            </button>



            <Modal
                show={showModalSetting}
                size="xl"
                onHide={() => setshowModalSetting(false)}
                aria-labelledby="example-custom-modal-styling-title"
                centered
                dialogClassName="sp-cfg-dialog"
                contentClassName="sp-cfg-content"
            >
                <Modal.Body className="sp-cfg">

                    {/* Header */}
                    <div className="sp-cfg__head">
                        {/* <div className="sp-cfg__badge"><i className="uil uil-setting"></i></div> */}
                        <h3 className="sp-cfg__title">Configuración</h3>
                        <button className="sp-cfg__x" type="button" aria-label="Cerrar" onClick={() => setshowModalSetting(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    {/* Tabs */}
                    <div className="sp-cfg__tabs">
                        <button type="button" className={`sp-cfg__tab ${settingTab === 'home' ? 'is-active' : ''}`} onClick={() => setSettingTab('home')}>
                            <i className="uil uil-info-circle"></i> Generales
                        </button>
                        <RenderIf isTrue={checkUserPermission("pos_config", user.permissions) !== -1}>
                            <button type="button" className={`sp-cfg__tab ${settingTab === 'profile' ? 'is-active' : ''}`} onClick={() => setSettingTab('profile')}>
                                <i className="uil uil-card-atm"></i> Metodos de pago
                            </button>
                            <button type="button" className={`sp-cfg__tab ${settingTab === 'contact' ? 'is-active' : ''}`} onClick={() => setSettingTab('contact')}>
                                <i className="uil uil-print"></i> Impresoras
                            </button>
                            <button type="button" className={`sp-cfg__tab ${settingTab === 'tables' ? 'is-active' : ''}`} onClick={() => setSettingTab('tables')}>
                                <i className="uil uil-restaurant"></i> Mesa
                            </button>
                            <RenderIf isTrue={business.posIntegrations && business.posIntegrations.length > 0}>
                                <button type="button" className={`sp-cfg__tab ${settingTab === 'integrations' ? 'is-active' : ''}`} onClick={() => setSettingTab('integrations')}>
                                    <i className="uil uil-plug"></i> Integraciones
                                </button>
                            </RenderIf>
                            <button type="button" className={`sp-cfg__tab ${settingTab === 'temporal' ? 'is-active' : ''}`} onClick={() => { setSettingTab('temporal'); getTemporalOrdersByBranch(); }}>
                                <i className="uil uil-bell-school"></i> Temporales
                            </button>
                        </RenderIf>
                    </div>

                    {/* Contenido */}
                    <div className="sp-cfg__content">

                        {/* ===== Generales ===== */}
                        {settingTab === 'home' && (
                            <div className="sp-cfg__pane">
                                <h3 className="sp-cfg__op"><i className="uil uil-user"></i> Operador: {user.name}</h3>

                                <div className="sp-cfg__switches">
                                    <RenderIf isTrue={checkUserPermission("view_disabled_partners", user.permissions) !== -1}>
                                        <label className="sp-cfg__switch">
                                            <span>{switchExternalMenu === true ? "Restaurantes socios activados" : "Restaurantes socios desactivados"}</span>
                                            <input type="checkbox" id="external1" checked={switchExternalMenu === true ? true : false} onChange={handleSwitchChange} />
                                            <span className="sp-cfg__sw" aria-hidden="true"></span>
                                        </label>
                                    </RenderIf>
                                    <RenderIf isTrue={checkUserPermission("edit_product_prices", user.permissions) !== -1}>
                                        <label className="sp-cfg__switch">
                                            <span>{editPrice === true ? "Editar precios activado" : "Editar precios desactivado"}</span>
                                            <input type="checkbox" id="editPrice" checked={editPrice === true ? true : false} onChange={handleSwitchChangeEditPrice} />
                                            <span className="sp-cfg__sw" aria-hidden="true"></span>
                                        </label>
                                    </RenderIf>
                                </div>

                                <div className="sp-cfg__grid2">
                                    {/* Columna izquierda */}
                                    <div className="sp-cfg__fields">
                                        <div className="sp-cfg__field"><span className="sp-cfg__label">Negocio:</span><div className="sp-cfg__value">{business.name}</div></div>
                                        <div className="sp-cfg__field"><span className="sp-cfg__label">Codigo de negocio:</span><div className="sp-cfg__value">{business.code}</div></div>
                                        <div className="sp-cfg__field"><span className="sp-cfg__label">Sucursal:</span><div className="sp-cfg__value">{branchoffice.name}</div></div>
                                        <div className="sp-cfg__field"><span className="sp-cfg__label">Codigo de sucursal:</span><div className="sp-cfg__value">{branchoffice.code}</div></div>
                                        <div className="sp-cfg__field"><span className="sp-cfg__label">¿Utilizan meseros en esta sucursal?</span><div className="sp-cfg__value">{branchoffice.waiters_enabled === 1 ? "Sí" : "No"}</div></div>
                                        <div className="sp-cfg__field"><span className="sp-cfg__label">¿Se pedira codigo de usuario para acceso?</span><div className="sp-cfg__value">{machine.user_code_validation === 1 ? "Sí" : "No"}</div></div>
                                        <RenderIf isTrue={machine.user_code_validation === 1}>
                                            <div className="sp-cfg__field"><span className="sp-cfg__label">Metodo de acceso del usuario:</span><div className="sp-cfg__value">{machine.user_code_auth_mode === "code_only" ? "Solo código" : "Código y contraseña"}</div></div>
                                        </RenderIf>
                                        <div className="sp-cfg__field"><span className="sp-cfg__label">¿Se auto aprobara ordenes de ecommerce - delivery?</span><div className="sp-cfg__value">{branchoffice.ecommerce_auto_approval_orders === 1 ? "Sí" : "No"}</div></div>
                                        <div className="sp-cfg__field">
                                            <span className="sp-cfg__label">Probar sonido</span>
                                            <div>
                                                <RenderIf isTrue={alarmActive === false || alarmActive === null}>
                                                    <button className="sp-cfg__btn sp-cfg__btn--outline" onClick={() => startAlarm()}>Probar jingle <i className="uil uil-music-note"></i></button>
                                                </RenderIf>
                                                <RenderIf isTrue={alarmActive === true}>
                                                    <button className="sp-cfg__btn sp-cfg__btn--outline" onClick={() => stopAlarm()}>Parar jingle <i className="uil uil-music-note"></i></button>
                                                </RenderIf>
                                            </div>
                                        </div>
                                        <div className="sp-cfg__field">
                                            <span className="sp-cfg__label">Bodega asignada:</span>
                                            <div>
                                                <button className="sp-cfg__btn sp-cfg__btn--outline" onClick={() => setShowModalWarehouses(true)}>
                                                    <i className="uil uil-database-alt"></i> {warehouseSelected.name ? <>{warehouseSelected.name}</> : <>Selecciona una bodega</>}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Columna derecha */}
                                    <div className="sp-cfg__fields">
                                        <div className="sp-cfg__field"><span className="sp-cfg__label">Tipo de maquina:</span><div className="sp-cfg__value">{machine.name_type_machine}</div></div>
                                        <div className="sp-cfg__field"><span className="sp-cfg__label">Nombre de la caja:</span><div className="sp-cfg__value">{machine_name_get}</div></div>
                                        <div className="sp-cfg__field"><span className="sp-cfg__label">Codigo de maquina:</span><div className="sp-cfg__value">{machine.code}</div></div>
                                        <div className="sp-cfg__field">
                                            <span className="sp-cfg__label">Idioma:</span>
                                            <div className="sp-cfg__value sp-cfg__lang">
                                                <img className="sp-cfg__flag" loading="lazy" src={buildCloudinaryImageUrl({ url: infolanguage.language.image_url, width: 300, quality: "auto", type: "image" }) || defaultImage} alt="" /> {infolanguage.language.name}
                                            </div>
                                        </div>
                                        <RenderIf isTrue={branchoffice.ecommerce_auto_approval_orders === 1}>
                                            <div className="sp-cfg__field"><span className="sp-cfg__label">Codigo de maquina donde se auto aprobaran las ordenes de ecommerce - delivery:</span><div className="sp-cfg__value">{branchoffice.auto_approval_machine_code}</div></div>
                                        </RenderIf>
                                        <div className="sp-cfg__field"><span className="sp-cfg__label">Tiempo para aprobar ordenes pickup y delivery programado (en minutos):</span><div className="sp-cfg__value">{branchoffice.approval_lead_time_minutes} minutos</div></div>
                                        <div className="sp-cfg__field">
                                            <span className="sp-cfg__label">Cambiar idioma:</span>
                                            <div className="sp-cfg__langrow">
                                                <select className="sp-cfg__select" aria-label="Default select example" onChange={(e) => (setSelectLanguage(e.target.value))}>
                                                    <option>Seleccione el idioma</option>
                                                    {viewLanguages()}
                                                </select>
                                                <button className="sp-cfg__btn sp-cfg__btn--primary" onClick={async () => (updateLanguage())}>Guardar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ===== Métodos de pago ===== */}
                        {settingTab === 'profile' && (
                            <div className="sp-cfg__pane">
                                <h3 className="sp-cfg__panetitle"><i className="uil uil-transaction"></i> Métodos de pago</h3>
                                <div className="sp-cfg__center">
                                    <ListGroup as="ol" numbered>
                                        {viewPaymentlist()}
                                    </ListGroup>
                                </div>
                            </div>
                        )}

                        {/* ===== Mesa ===== */}
                        {settingTab === 'tables' && (
                            <div className="sp-cfg__pane">
                                <TableSettingsTab />
                            </div>
                        )}

                        {/* ===== Impresoras ===== */}
                        {settingTab === 'contact' && (
                            <div className="sp-cfg__pane">
                                <h3 className="sp-cfg__panetitle"><i className="uil uil-print"></i> Impresoras</h3>

                                {localStorage.getItem('ip_printer') != null && localStorage.getItem('ip_printer') != undefined && localStorage.getItem('ip_printer') != "" ?
                                    <div className="sp-cfg__center">
                                        <button className="sp-cfg__btn sp-cfg__btn--danger" onClick={() => (removedIpExternalPrinter())}>
                                            <i className="uil uil-trash-alt"></i> Remover ip de impresora externa: {localStorage.getItem('ip_printer')}
                                        </button>
                                    </div> : <>
                                        <div className="sp-cfg__center">
                                            <button className="sp-cfg__btn sp-cfg__btn--primary" onClick={() => (setshowModalipPrinterAdd(true), setIp_printerInput(""))}>
                                                <i className="uil uil-save"></i> Agregar ip impresion externa
                                            </button>
                                        </div>
                                    </>}

                                <div className="sp-cfg__center ">
                                    {viewPrinterlist()}                       
                                </div>
                            </div>
                        )}

                        {/* ===== Temporales ===== */}
                        {settingTab === 'temporal' && (
                            <div className="sp-cfg__pane">
                                <h3 className="sp-cfg__panetitle"><i className="uil uil-bell-school"></i> Temporales en proceso</h3>
                                <div className="sp-cfg__temporals">
                                    {temporalOrders.length === 0 && (
                                        <div className="sp-cfg__empty">No hay órdenes temporales</div>
                                    )}
                                    {temporalOrders.map(order => (
                                        <div className="sp-cfg__tcard" key={order.code}>
                                            <h5 className="sp-cfg__tcard-title">Orden: {order.transaction_code}</h5>
                                            <h5 className="sp-cfg__tcard-title">Tipo: {order.is_discount_notification === true ? "Descuento" : <> {order.is_devolution_notification === true ? "Devolucion" : "Normal"}</>}</h5>
                                            <h6 className="sp-cfg__tcard-sub">Cliente: {order.client_name}</h6>
                                            <div><b>Negocio:</b> {order.business?.name}</div>
                                            <div><b>Sucursal:</b> {order.branchoffice?.name}</div>
                                            <div><b>Fecha:</b> {order.createdAt?.slice(0, 19).replace('T', ' ')}</div>
                                            <div><b>Total:</b> ${order.total}</div>
                                            <div className="sp-cfg__tcard-acts">
                                                <button className="sp-cfg__btn sp-cfg__btn--danger" onClick={async () => {
                                                    await updateTemReturn(order.code, 5, "Eliminando...", "Eliminando", "info", false);
                                                }}>
                                                    <i className="uil uil-trash-alt"></i> Eliminar
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* ===== Integraciones ===== */}
                        <RenderIf isTrue={business.posIntegrations && business.posIntegrations.length > 0}>
                            {settingTab === 'integrations' && (
                                <div className="sp-cfg__pane">
                                    <h3 className="sp-cfg__panetitle"><i className="uil uil-plug"></i> Integraciones</h3>
                                    <div>
                                        <IntegrationsList business={business} branchoffice={branchoffice} token={token} />
                                    </div>
                                </div>
                            )}
                        </RenderIf>
                    </div>

                    {/* Footer */}
                    <div className="sp-cfg__foot">
                        <button className="sp-cfg__btn sp-cfg__btn--primary" onClick={() => (setshowModalSetting(false))}>Cerrar</button>
                    </div>

                </Modal.Body>
            </Modal>


            {/* Modal EBT */}
            <Modal show={ebtBalanceModal} onHide={() => setEbtBalanceModal(false)} centered dialogClassName="sp-cfg-mini-dialog" contentClassName="sp-cfg-content">
                <Modal.Body className="sp-cfgmini">
                    <div className="sp-cfgmini__head">
                        <h5 className="sp-cfgmini__title">Información</h5>
                        <button className="sp-cfg__x" type="button" aria-label="Cerrar" onClick={() => setEbtBalanceModal(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>
                    <div className="sp-cfgmini__voucher">
                        <RenderIf isTrue={ebtVoucher !== null}><pre>{ebtVoucher}</pre></RenderIf>
                        <RenderIf isTrue={ebtVoucher === null}><pre>No se genero voucher</pre></RenderIf>
                    </div>
                    <div className="sp-cfgmini__acts">
                        <button className="sp-cfg__btn sp-cfg__btn--outline" onClick={() => setEbtBalanceModal(false)}>Cerrar</button>
                        <button className="sp-cfg__btn sp-cfg__btn--ok" onClick={() => setEbtBalanceModal(false)}>Imprimir</button>
                    </div>
                </Modal.Body>
            </Modal>


            {/* Modal agregar IP impresora */}
            <Modal
                show={showModalipPrinterAdd}
                size="sm-down"
                centered
                onHide={() => (setshowModalipPrinterAdd(false), setIp_printerInput(""))}

            >
                <Modal.Body className="sp-cfgmini rounded-5">
                    <div className="sp-cfgmini__head sp-cfgmini__head--center">
                        {/* <div className="sp-cfg__badge sp-cfg__badge--sm"><i className="uil uil-file-question-alt"></i></div> */}
                        <h1 className="sp-cfgmini__title">Ingresa la ip de impresion externa</h1>
                    </div>

                    <div className="sp-cfgmini__field">
                        <label className="sp-cfg__label">Ip o direccion externa:</label>
                        <textarea className="sp-cfg__textarea" rows={1} onChange={(e) => (setIp_printerInput(e.target.value))}></textarea>
                    </div>

                    <div className="sp-cfgmini__acts sp-cfgmini__acts--split">
                        <button className="sp-cfg__btn sp-cfg__btn--ghost" onClick={() => (setshowModalipPrinterAdd(false), setIp_printerInput(""))}>Cancelar</button>
                        <button className="sp-cfg__btn sp-cfg__btn--primary" onClick={() => (saveipPinter())}>
                            <i className="uil uil-save"></i> Guardar
                        </button>
                    </div>
                </Modal.Body>
            </Modal>



            <ModalWarehouses show={showModalWarehouses} setShow={setShowModalWarehouses} warehouses={warehouses} setWarehouseSelected={setWarehouseSelected}></ModalWarehouses>








        </>
    )
}

export default ModalSetting